import React from 'react';
import Hero from '../components/Hero/Hero';
import ProductCarousel from '../components/ProductCarousel/ProductCarousel';
import AboutContactPreview from './AboutContactPreview.js';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <ProductCarousel/>
      <AboutContactPreview />
    </div>
  );
};

export default Home;